import FormattedMessage from 'I18n/components/FormattedMessage';
import { useState, useCallback } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Alert } from 'foundations-components/transitional/components/Alert';
import CampaignSelectFormControl from 'campaigns-lib/components/campaignSelect/CampaignSelectFormControl';
import { H2 } from 'foundations-components/transitional/components/H2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function CampaignsPlatformEditModalLegacy({
  onClose,
  assetObjectType,
  hasCampaignsWriteAccess,
  onEditCampaignConfirm,
  selectedCampaign,
  customAlert,
  isLoading,
  multi
}) {
  const [selectedOption, setSelectedOption] = useState(() => ({
    value: selectedCampaign,
    colorHex: null,
    text: undefined,
    utm: null
  }));
  const onCampaignOptionChange = useCallback((newValue, options) => {
    var _option$colorHex, _option$utm;
    const option = Array.isArray(options) ? options[0] : options;
    setSelectedOption({
      value: newValue,
      colorHex: (_option$colorHex = option === null || option === void 0 ? void 0 : option.colorHex) !== null && _option$colorHex !== void 0 ? _option$colorHex : null,
      text: option === null || option === void 0 ? void 0 : option.text,
      utm: (_option$utm = option === null || option === void 0 ? void 0 : option.utm) !== null && _option$utm !== void 0 ? _option$utm : null
    });
  }, []);
  return /*#__PURE__*/_jsxs(Modal, {
    width: 540,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "campaignSelect.selectMarketingCampaign"
        })
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx(CampaignSelectFormControl, {
        assetObjectType: assetObjectType,
        "data-test-id": "details-edit-campaign-select",
        hasCampaignsReadAccess: true,
        hasCampaignsWriteAccess: hasCampaignsWriteAccess,
        onChange: ({
          target: {
            value
          }
        }, option) => onCampaignOptionChange(value, option),
        value: selectedOption.value,
        withCampaignAutoSelectPopover: true,
        multi: multi
      }), customAlert !== null && customAlert !== void 0 ? customAlert : /*#__PURE__*/_jsx(Alert, {
        marginBlockStart: "500",
        type: "info",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          "data-test-id": "details-edit-campaign-warning",
          message: "campaignSelect.details"
        })
      })]
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(LoadingButton, {
        onClick: () => {
          onEditCampaignConfirm(selectedOption);
          onClose();
        },
        use: "primary",
        disabled: isLoading,
        "data-test-id": "confirm-select-button",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "campaignSelect.saveEditCampaign"
        })
      }), /*#__PURE__*/_jsx(Button, {
        onClick: onClose,
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "campaignSelect.cancelEditCampaign"
        })
      })]
    })]
  });
}
export default CampaignsPlatformEditModalLegacy;